/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Launch_Tools_This_WeekInputs */

const en_directory_launch_tools_this_week = /** @type {(inputs: Directory_Launch_Tools_This_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} tools added this week`)
};

const zh_directory_launch_tools_this_week = /** @type {(inputs: Directory_Launch_Tools_This_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`本周新增 ${i?.count} 个工具`)
};

/**
* | output |
* | --- |
* | "{count} tools added this week" |
*
* @param {Directory_Launch_Tools_This_WeekInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_tools_this_week = /** @type {((inputs: Directory_Launch_Tools_This_WeekInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Tools_This_WeekInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_tools_this_week(inputs)
	return zh_directory_launch_tools_this_week(inputs)
});
export { directory_launch_tools_this_week as "directory.launch.tools_this_week" }